import bizAiService from '@/modules/bizAi/services/bizAiService';

const state = {
  recommendations: [],
};

const mutations = {
  setRecommendations(state, value) {
    state.recommendations = value;
  },
};

const actions = {
  /**
   * Fetch recommendations - This method fetches the recommendations from the backend.
   * its can also fetch recommendations based on a specific matter.
   * @param commit
   * @param params
     * @param params.target - the staff uid to fetch recommendations for
     * @param params.context - the matter uid to fetch recommendations for
   * @returns {Promise<void>}
   */
  async fetchRecommendations({commit}, params) {
    let recommendations = [];
    try {
      recommendations = await bizAiService.getRecommendations(params);
      commit('setRecommendations', recommendations);
    } catch (error) {
      console.error('Failed to fetch recommendations', error);
    }
  },
  /**
   * Update recommendation - This method serves as a way to update the recommendation status.
   * It can be used to either dismiss it on the backend, when the user dismissed it,
   * or simply hide it from the display, usually when a user activates an action from the recommendation.
   * @param commit
   * @param uid
   * @param dismissed - when true, a call will go to bizai service to mark the recommendation as dismissed
   * @returns {Promise<void>}
   */
  async updateRecommendation({commit}, {uid, dismissed = false}) {
    if (dismissed) {
      try {
        await bizAiService.updateRecommendation(uid, dismissed);
      } catch (error) {
        console.error('Failed to update recommendation', error);
      }
    }
    const newRecommendations = state.recommendations.filter((rec) => rec.uid !== uid);
    commit('setRecommendations', newRecommendations);
  },
  async clearRecommendations({commit}) {
    commit('setRecommendations', []);
  }
};

const getters = {
  recommendations: (state) => state.recommendations,
  getRecommendationByMatter: (state) => (matter_uid) => state.recommendations?.find(recommendation => recommendation.context.context_uid === matter_uid),
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
